<template lang="pug">
#public_info
  .container.custom_container_lg
    .row
      breadcrumb
  .container.i_mt_14.i_mt_md_10
    .row.text-center.flex-column
      h2.title 公開依據
      p.i_body_l {{ publicInfomation.area01_Title01 }}
    .row.i_mt_8
      .col-12
        p.i_body_l(v-html="publicInfomation.area01_Content01")

  .container.i_mt_8
    .row.text-center.flex-column
      h2.title 公開資訊內容
    .img.i_mt_4(
      v-if="publicInfomation",
      :style="{ backgroundImage: 'url(' + publicInfomation.area02_BannerPC + ')' }"
    )
    .row.i_mt_8
      .col-6.i_mb_9.i_mb_md_7.i_mb_sm_8(
        v-for="(item, index) in itemList",
        :key="index"
      )
        item(:item="item")
    .row
      a.btn_round(:href="publicInfomation.area02_BtnURL", target="_blank") {{ publicInfomation.area02_BtnName }}

  .container.i_mt_14.i_mt_md_10.list_items
    .row.text-center.flex-column
      h2.title 其他揭露項目
    .row.i_mt_10.i_mt_md_6
      a.col-md-6.d-flex.i_mb_2(
        v-for="(listItem, index) in publicInfomation.area02_ExposeItemList",
        :key="index",
        :href="listItem.ItemUrl"
      )
        svg-icon.i_mt_1(iconClass="ic_download", className="icon")
        p.i_body_l.i_ml_2 {{ listItem.ItemName }}

  section.difference.container
    .row
      .col-md-6.text-center.i_mt_6
        .feature.i_mr_1.i_ptb_7.i_plr_10.i_ptb_md_6.i_plr_md_8.i_plr_sm_12
          .wrapper.d-flex.flex-md-column.flex-lg-row.align-items-center.justify-content-center
            img(:src="publicInfomation.area03_Icon01")
            h5.i_ml_5.i_ml_md_0.i_ml_sm_5 {{ publicInfomation.area03_SubTitle01 }}
          p.i_mt_4 {{ publicInfomation.area03_Content01 }}
          router-link.see_more_btn.sm.btn_blue_ci.i_mt_20.i_mt_sm_10(
            tag="a",
            :to="{ name: 'CustomerServiceDocumentDownloadTerms' }"
          ) 查看商品條款
      .col-md-6.text-center.i_mt_6
        .feature.i_ml_1.i_ptb_7.i_plr_10.i_ptb_md_6.i_plr_md_8.i_plr_sm_12
          .wrapper.d-flex.flex-md-column.flex-lg-row.align-items-center.justify-content-center
            img(:src="publicInfomation.area03_Icon02")
            h5.i_ml_5.i_ml_md_0.i_ml_sm_5 {{ publicInfomation.area03_SubTitle02 }}
          p.title.i_mt_4 {{ publicInfomation.area03_Year }}
          .month_wrapper.d-flex.i_mt_1
            p.month.flex-shrink-0 {{ publicInfomation.area03_Month01 }}

            p.i_ml_4 {{ publicInfomation.area03_MonthContent01 }}
          .month_wrapper.d-flex.i_mt_1
            p.month.flex-grow-1.flex-shrink-0 {{ publicInfomation.area03_Month02 }}

            p.i_ml_4 {{ publicInfomation.area03_MonthContent02 }}
          router-link.see_more_btn.sm.btn_blue_ci.i_mt_20.i_mt_sm_10(
            tag="a",
            :to="{ name: 'AboutUsPublicInfoMessage' }"
          ) 查看重大訊息
</template>

<script>
import Item from "@/components/about_us/public_info/Item";
import { getPublicInfomation } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "AboutUsPublicInfo",
  metaInfo() {
    return {
      title: this.publicInfomation.SEO_Title,
      meta: [
        { name: "description", content: this.publicInfomation.SEO_Description },
      ],
    };
  },
  components: { item: Item, breadcrumb: Breadcrumb },
  data() {
    return {
      publicInfomation: {},
      itemList: [],
    };
  },
  created() {
    this.getPublicInfomation();
  },
  methods: {
    getPublicInfomation() {
      getPublicInfomation().then((response) => {
        this.publicInfomation = response.data;
        this.itemList = [];

        let tempFile1 = {
          title: this.publicInfomation.area02_SubTitle01,
          content: this.publicInfomation.area02_Content01,
          img: this.publicInfomation.area02_Icon01,
        };
        this.itemList.push(tempFile1);
        let tempFile2 = {
          title: this.publicInfomation.area02_SubTitle02,
          content: this.publicInfomation.area02_Content02,
          img: this.publicInfomation.area02_Icon02,
        };
        this.itemList.push(tempFile2);
        let tempFile3 = {
          title: this.publicInfomation.area02_SubTitle03,
          content: this.publicInfomation.area02_Content03,
          img: this.publicInfomation.area02_Icon03,
        };
        this.itemList.push(tempFile3);
        let tempFile4 = {
          title: this.publicInfomation.area02_SubTitle04,
          content: this.publicInfomation.area02_Content04,
          img: this.publicInfomation.area02_Icon04,
        };
        this.itemList.push(tempFile4);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/profile";
@import "@/assets/style/about_us/public_info";
</style>
